(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    const form = root.querySelector('[data-dk-refine]');
    const grid = root.querySelector('[data-dk-grid]');
    if (!form || !grid) return;
    root.dataset.ready = 'true';
    root.classList.add('is-enhanced');

    const sortField = form.querySelector('[data-dk-sort]');
    const clearLink = form.querySelector('[data-dk-clear]');
    const active = form.querySelector('[data-dk-active]');
    const countLabel = root.querySelector('.dk-result-count');
    const sectionId = root.closest('.shopify-section')?.id?.replace(/^shopify-section-/, '');
    let renderedSort = new URL(location.href).searchParams.get('sort_by') || 'manual';
    let sortRequest;
    let pageRequest;
    let generation = 0;
    let loadingSort = false;

    const priceMatches = (code, amount, family) => {
      if (!code) return true;
      if (!amount) return false;
      if (code === 'p1') return amount <= 200000;
      if (code === 'p2') return amount > 200000 && amount <= 800000;
      if (code === 'p3') return amount > 800000 && amount <= 1600000;
      if (code === 'p4') return amount > 1600000 && amount <= 3000000;
      if (code === 'p5') return amount > 3000000;
      if (code[0] !== { deri: 'd', lake: 't', mucevher: 'm' }[family]) return false;
      if (code === 'd1') return amount <= 160000;
      if (code === 'd2') return amount > 160000 && amount <= 220000;
      if (code === 'd3') return amount > 220000;
      if (code === 't1') return amount <= 1200000;
      if (code === 't2') return amount > 1200000 && amount < 2300000;
      if (code === 't3') return amount >= 2300000;
      if (code === 'm1') return amount < 3000000;
      if (code === 'm2') return amount >= 3000000;
      return true;
    };

    const groupMatches = (groups, card) => {
      if (!groups.length) return true;
      const tags = (card.dataset.dkTags || '').split(/\s+/);
      const name = card.dataset.dkName || '';
      return groups.some((value) => {
        if (value.startsWith('cek-')) return name.includes(`${value.slice(4)} Çekmeceli`);
        if (value.startsWith('kap-')) {
          if (tags.includes(value)) return true;
          const count = value.slice(4);
          return [` ${count}'lı`, ` ${count}'li`, ` ${count}’lı`, ` ${count}’li`, ` ${count} Saat`, ` ${count} Bölmeli`]
            .some((pattern) => name.includes(pattern))
            || [`${count} Saat`, `${count} Bölmeli`, `${count}'lı`, `${count}'li`].some((pattern) => name.startsWith(pattern));
        }
        return tags.includes(value);
      });
    };

    const selectedGroups = () => [...form.querySelectorAll('input[name="grup"]:checked')].map((field) => field.value);
    const selectedColors = () => [...form.querySelectorAll('input[name="renk"]:checked')].map((field) => field.value);
    const selectedPrice = () => form.querySelector('input[name="fiyat"]:checked')?.value || '';
    const familyOf = (card) => {
      const tags = (card.dataset.dkTags || '').split(/\s+/);
      if (tags.includes('deri')) return 'deri';
      if (tags.includes('mücevher-kutusu')) return 'mucevher';
      return card.dataset.dkFamily || 'lake';
    };

    const syncControls = () => {
      const params = new URL(location.href).searchParams;
      const groups = params.getAll('grup');
      form.querySelectorAll('input[name="grup"]').forEach((field) => { field.checked = groups.includes(field.value); });
      const colors = params.getAll('renk');
      form.querySelectorAll('input[name="renk"]').forEach((field) => { field.checked = colors.includes(field.value); });
      const price = params.get('fiyat') || '';
      form.querySelectorAll('input[name="fiyat"]').forEach((field) => { field.checked = field.value === price; });
      if (sortField) sortField.value = params.get('sort_by') || 'manual';
    };

    const writeURL = (method = 'pushState') => {
      const url = new URL(location.href);
      url.searchParams.delete('grup');
      url.searchParams.delete('renk');
      url.searchParams.delete('fiyat');
      url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      selectedGroups().forEach((group) => url.searchParams.append('grup', group));
      selectedColors().forEach((color) => url.searchParams.append('renk', color));
      if (selectedPrice()) url.searchParams.set('fiyat', selectedPrice());
      if (sortField?.value && sortField.value !== 'manual') url.searchParams.set('sort_by', sortField.value);
      if (url.href !== location.href) history[method]({}, '', url);
    };

    const render = () => {
      const groups = selectedGroups();
      const colors = selectedColors();
      const price = selectedPrice();
      let count = 0;
      grid.querySelectorAll('[data-dk-product]').forEach((card) => {
        const cardColors = [card.dataset.dkColor || '', ...[...card.querySelectorAll('.dk-card__swatch')].map((swatch) => swatch.title)];
        card.hidden = !(groupMatches(groups, card)
          && (!colors.length || colors.some((color) => cardColors.includes(color)))
          && priceMatches(price, Number(card.dataset.dkPrice || 0), familyOf(card)));
        if (!card.hidden) count += 1;
      });
      if (countLabel) countLabel.textContent = `${count} ürün`;
      if (clearLink) clearLink.hidden = !groups.length && !colors.length && !price;

      if (active) {
        active.replaceChildren();
        form.querySelectorAll('input[name="grup"]:checked, input[name="renk"]:checked, input[name="fiyat"]:checked').forEach((field) => {
          if (!field.value) return;
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'dk-refine__chip';
          chip.dataset.removeName = field.name;
          chip.dataset.removeValue = field.value;
          chip.textContent = field.closest('label')?.textContent.trim() || field.value;
          chip.setAttribute('aria-label', `${chip.textContent} filtresini kaldır`);
          active.append(chip);
        });
        active.hidden = !active.childElementCount;
      }

      let empty = root.querySelector('.dk-refine__empty');
      if (!count && !empty && countLabel) {
        empty = document.createElement('p');
        empty.className = 'dk-refine__empty';
        empty.textContent = 'Bu seçime uyan ürün yok. ';
        const reset = document.createElement('button');
        reset.type = 'button';
        reset.dataset.dkReset = '';
        reset.textContent = 'Filtreleri temizle';
        empty.append(reset);
        countLabel.insertAdjacentElement('afterend', empty);
      } else if (count && empty) {
        empty.remove();
      }
      root.removeAttribute('data-dk-filter-pending');
    };

    const resetFilters = () => {
      form.querySelectorAll('input[name="grup"]').forEach((field) => { field.checked = false; });
      form.querySelectorAll('input[name="renk"]').forEach((field) => { field.checked = false; });
      form.querySelectorAll('input[name="fiyat"]').forEach((field) => { field.checked = !field.value; });
      render();
      writeURL();
    };

    const fetchSection = async (url, signal) => {
      const requestURL = new URL(url, location.origin);
      if (sectionId) requestURL.searchParams.set('section_id', sectionId);
      const response = await fetch(requestURL, { signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const section = page.querySelector('[data-dk-catalog]');
      if (!section?.querySelector('[data-dk-grid]')) throw new Error('Katalog bölümü bulunamadı');
      return section;
    };

    const hydratePages = async (currentGeneration) => {
      pageRequest?.abort();
      pageRequest = new AbortController();
      let next = root.querySelector('[data-dk-next]');
      while (next && currentGeneration === generation) {
        try {
          const section = await fetchSection(next.href, pageRequest.signal);
          if (currentGeneration !== generation) return;
          section.querySelectorAll('[data-dk-product]').forEach((card) => grid.append(card));
          document.dispatchEvent(new Event('dk:content'));
          const incoming = section.querySelector('[data-dk-next]');
          if (incoming) next.href = incoming.href;
          else {
            root.querySelector('.dk-load')?.remove();
            next = null;
          }
          render();
        } catch (error) {
          if (error.name === 'AbortError') return;
          root.classList.remove('is-enhanced');
          return;
        }
      }
    };

    const sortCollection = async (sort, shouldWriteURL = true) => {
      if (sort === renderedSort) {
        if (loadingSort) {
          sortRequest?.abort();
          generation += 1;
          loadingSort = false;
          root.classList.remove('is-sorting');
          hydratePages(generation);
        }
        render();
        if (shouldWriteURL) writeURL();
        return;
      }
      sortRequest?.abort();
      pageRequest?.abort();
      const request = new AbortController();
      sortRequest = request;
      const requestGeneration = ++generation;
      loadingSort = true;
      const url = new URL(form.action, location.origin);
      if (sort !== 'manual') url.searchParams.set('sort_by', sort);
      root.classList.add('is-sorting');
      if (countLabel) countLabel.textContent = 'Ürünler sıralanıyor…';
      try {
        const section = await fetchSection(url, request.signal);
        if (requestGeneration !== generation) return;
        const incomingGrid = section.querySelector('[data-dk-grid]');
        grid.replaceChildren(...incomingGrid.children);
        root.querySelector('.dk-load')?.remove();
        const incomingLoad = section.querySelector('.dk-load');
        if (incomingLoad) grid.insertAdjacentElement('afterend', incomingLoad);
        renderedSort = sort;
        document.dispatchEvent(new Event('dk:content'));
        render();
        if (shouldWriteURL) writeURL();
        hydratePages(requestGeneration);
      } catch (error) {
        if (error.name !== 'AbortError') {
          if (sortField) sortField.value = renderedSort;
          render();
          root.querySelector('[data-dk-sort-error]')?.remove();
          const message = document.createElement('p');
          message.dataset.dkSortError = '';
          message.className = 'dk-refine__error';
          message.textContent = 'Sıralama yüklenemedi. Tekrar deneyin.';
          form.insertAdjacentElement('afterend', message);
        }
      } finally {
        if (requestGeneration === generation) {
          loadingSort = false;
          root.classList.remove('is-sorting');
        }
      }
    };

    syncControls();
    render();
    const initialParams = new URL(location.href).searchParams;
    if (['grup', 'renk', 'fiyat'].some((key) => initialParams.has(key))) {
      const initialGeneration = generation;
      const canonicalURL = new URL(form.action, location.origin);
      if (renderedSort !== 'manual') canonicalURL.searchParams.set('sort_by', renderedSort);
      fetchSection(canonicalURL).then((section) => {
        if (initialGeneration !== generation) return;
        grid.replaceChildren(...section.querySelector('[data-dk-grid]').children);
        root.querySelector('.dk-load')?.remove();
        const incomingLoad = section.querySelector('.dk-load');
        if (incomingLoad) grid.insertAdjacentElement('afterend', incomingLoad);
        document.dispatchEvent(new Event('dk:content'));
        render();
        hydratePages(initialGeneration);
      }).catch(() => {
        root.classList.remove('is-enhanced');
      });
    } else {
      hydratePages(generation);
    }

    form.addEventListener('change', (event) => {
      if (event.target === sortField) {
        root.querySelector('[data-dk-sort-error]')?.remove();
        sortCollection(sortField.value);
      } else if (event.target.matches('input[name="grup"], input[name="renk"], input[name="fiyat"]')) {
        render();
        writeURL();
      }
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      render();
      writeURL();
    });
    clearLink?.addEventListener('click', (event) => {
      event.preventDefault();
      resetFilters();
    });
    active?.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-remove-name]');
      if (!chip) return;
      const field = [...form.querySelectorAll('input')].find((input) => input.name === chip.dataset.removeName && input.value === chip.dataset.removeValue);
      if (field) field.checked = false;
      if (chip.dataset.removeName === 'fiyat') {
        const allPrices = form.querySelector('input[name="fiyat"][value=""]');
        if (allPrices) allPrices.checked = true;
      }
      render();
      writeURL();
    });
    root.addEventListener('click', (event) => {
      if (event.target.matches('[data-dk-reset]')) resetFilters();
    });
    window.addEventListener('popstate', () => {
      syncControls();
      sortCollection(sortField?.value || 'manual', false);
    });
  };

  document.querySelectorAll('[data-dk-catalog]').forEach(init);
})();
